import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import ListFlowRatesForm from '../Forms/ListFlowRatesForm';

const ListFlowRatesModal = ({
	dataParticipant,
	isOpen,
	isEdit,
	handleToggleModal,
	handleSave,
	selectedWaterSourceIds = []
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
			unmountOnClose={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Lista de Caudales
			</ModalHeader>

			<ListFlowRatesForm
				dataParticipant={dataParticipant}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				handleSave={handleSave}
				selectedWaterSourceIds={selectedWaterSourceIds}
			/>
		</Modal>
	);
};

export default ListFlowRatesModal;